import { useContext, useMemo } from 'react';
import { intentContext } from "../contexts/intentContext.js";
import { useActiveIntent } from "./useActiveIntent.js";
export function useActiveVariant() {
  const {
    activeVariantId,
    loadingStatus
  } = useContext(intentContext);
  const activeIntent = useActiveIntent();
  return useMemo(() => {
    if (loadingStatus !== 'loaded') {
      return undefined;
    }
    return activeIntent?.variants?.find(v => v.variantId === activeVariantId);
  }, [activeIntent, activeVariantId, loadingStatus]);
}